import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

import TrademarkEditor from "@/components/editors/trademark.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import {useRoute} from "vue-router"
  import {Trademark as TrademarkClient} from "@/endpoints/rutsolve/gql/resolvers/trademark"
  import {onBeforeMount, ref} from "vue"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  import ErrorModal from "@/components/modals/error.vue"
  import Button from "@/components/button.vue"
  import router from "@/router"
  import ConfirmationModal from "@/components/modals/confirmation.vue"

  
export default /*@__PURE__*/_defineComponent({
  __name: 'edit_trademark',
  setup(__props) {

  const error = ref<Error>(null)
  const trademarkClient = new TrademarkClient()
  const trademark = ref<Trademark>(null)
  const confirmRemove = ref<boolean>(false)

  onBeforeMount(() => {
    read()
  })

  async function read() {
    try {
      const trademarkID = useRoute().params.trademarkID.toString()
      trademark.value = await trademarkClient.summary(trademarkID)
    } catch(e) {
      error.value = e
    }
  }

  async function remove() {
    try {
      await trademarkClient.remove(trademark.value.id)
      trademarksRedirect()
    } catch(e) {
      error.value = e
    }
  }

  async function save() {
    try {
      await trademarkClient.update(trademark.value)
      trademarksRedirect()
    } catch(e) {
      error.value = e
    }
  }

  function trademarksRedirect() {
    router.push({
      name: "trademarks"
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createVNode(VerticalNavigator, null, {
        default: _withCtx(() => [
          (trademark.value)
            ? (_openBlock(), _createBlock(Breadcrumb, {
                key: 0,
                links: [{
          title: 'RutSolve',
          routeName: 'index'
        }, {
          title: 'Trademarks',
          routeName: 'trademarks'
        }],
                title: trademark.value.name
              }, null, 8, ["title"]))
            : _createCommentVNode("", true),
          _cache[6] || (_cache[6] = _createElementVNode("h1", null, " Edit Trademark ", -1)),
          _createVNode(TrademarkEditor, {
            value: trademark.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((trademark).value = $event))
          }, null, 8, ["value"]),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
          _createVNode(Button, {
            title: "Remove",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (confirmRemove.value = true))
          }),
          _createVNode(Button, {
            title: "Cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (trademarksRedirect()))
          }),
          _createVNode(Button, {
            title: "Save",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (save()))
          })
        ]),
        _: 1
      }),
      _createVNode(ConfirmationModal, {
        display: confirmRemove.value,
        "onUpdate:display": _cache[4] || (_cache[4] = ($event: any) => ((confirmRemove).value = $event)),
        callback: remove,
        message: "This action will remove selected trademark.",
        title: "Remove Trademark"
      }, null, 8, ["display"]),
      (error.value)
        ? (_openBlock(), _createBlock(ErrorModal, {
            key: 0,
            error: error.value,
            "onUpdate:error": _cache[5] || (_cache[5] = ($event: any) => ((error).value = $event))
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})